class CoctRobActions {
    static COCT_ROB_REQUEST = "COCT_ROB_REQUEST";
    static COCT_ROB_SUCCESSFUL = "COCT_ROB_SUCCESSFUL";
    static COCT_ROB_FAILED = "COCT_ROB_FAILED";

    static coctrobRequest() {
        return {
            type: this.COCT_ROB_REQUEST
        };
    }
    static coctrobSuccessful(data) {
        return {
            type: this.COCT_ROB_SUCCESSFUL,
            data
        };
    }
    static coctrobFailed(error) {
        return {
            type: this.COCT_ROB_FAILED,
            error
        };
    }
}

export default CoctRobActions;
